import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

import { SET_MENU } from '../../store/actions/menu';

import Header from './Header';
import Sidebar from './Sidebar';

import SEO from '../../elements/SEO';
import { BRAND_NAME } from '../../config/branding';
import { useEffect } from 'react';
import { getSkills } from '../../store/actions';
import { getCandidatesRole } from '../../store/actions/candidate';

const drawerWidth = 260;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open, user }) => ({
    ...(user?.userType === 'candidate' ? theme.typography.adminMainContent : theme.typography.mainContent),
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: -(drawerWidth - 20),
            width: '100%',
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            width: '100%',
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: user?.userType === 'candidate' ? '0px' : '10px',
            width: '100%',
            padding: '16px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));

const fullScreenRoute = []

const Layout = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const {candidateId} = useParams();
    const location = useLocation();

    const {leftDrawerOpened, user, userAuthenticated} = useSelector((state) => {
        return {
            leftDrawerOpened: state.customization.opened,
            user: state?.auth?.user,
            userAuthenticated: state?.auth?.accessToken
        }
    });
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };

    useEffect(()=>{
        dispatch(getSkills())
        dispatch(getCandidatesRole())
    },[])

    const fullPageRoutes = [
        `/404`,
    ];

    const fullPage = fullPageRoutes.includes(location.pathname);
    const isFullScreenRoute = fullScreenRoute?.find((value) => {
        return value.includes(location.pathname);
    });

  return (
    <Box sx={{ display: 'flex' }}>
      <SEO title={BRAND_NAME} />
      <CssBaseline />
        <AppBar
            enableColorOnDark
            position="fixed"
            color="inherit"
            elevation={0}
            sx={{
                bgcolor: theme.palette.background.default,
                transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
            }}
        >
              <Toolbar style={{ padding: '8px' }}>
                <Header handleLeftDrawerToggle={handleLeftDrawerToggle} fullPage={fullPage} userAuthenticated={userAuthenticated} />
              </Toolbar>
        </AppBar>

      {/* drawer */}
        {
            !fullPage && !!userAuthenticated ?
                <Sidebar
                    drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened}
                    drawerToggle={handleLeftDrawerToggle}
                /> : null
        }

      {/* main content */}
        <Main theme={theme} open={leftDrawerOpened} user={user}>
            <div style={{maxWidth: "unset", margin: "4rem 0 0 0"}}>
                <Outlet/>
            </div>
        </Main>
    </Box>
  );
};

export default Layout;
